export default "__VITE_ASSET__BStmzE3w__"